import React from "react";
import { Link } from "react-router-dom";
import founderPhoto from "../assets/Images/about-founder.png";

const About = () => {
  return (
    <div className="min-h-[calc(100vh-4rem)] bg-richblack-900 font-inter text-richblack-5">
      <div className="mx-auto w-11/12 max-w-maxContent py-14 md:py-20">
        <div className="mb-10 border-b border-richblack-700 pb-8">
          <h1 className="text-3xl font-semibold tracking-tight text-richblack-5 md:text-4xl">
            About <span className="text-yellow-50">StudyMeet</span>
          </h1>
        </div>

        <div className="flex flex-col gap-12 lg:flex-row lg:items-start lg:gap-14">
          <div className="mx-auto shrink-0 lg:mx-0">
            <div className="rounded-2xl border border-richblack-600 bg-richblack-800 p-1.5 shadow-[0_0_40px_-12px_rgba(255,214,10,0.25)]">
              <img
                src={founderPhoto}
                alt="Ajeet"
                className="aspect-square w-56 rounded-xl object-cover sm:w-64 md:w-72"
              />
            </div>
          </div>

          <div className="flex max-w-2xl flex-col gap-10 text-base leading-relaxed text-richblack-200">
            <section className="rounded-2xl border border-richblack-700 bg-richblack-800/60 p-6 md:p-8">
              <h2 className="mb-4 text-lg font-semibold text-richblack-5">
                About me
              </h2>
              <p>
                I’m Ajeet — I care about building products that make learning feel
                straightforward instead of overwhelming. I enjoy full-stack work,
                clear UX, and shipping things people can actually use every day.
              </p>
            </section>

            <section className="rounded-2xl border border-richblack-700 bg-richblack-800/60 p-6 md:p-8">
              <h2 className="mb-4 text-lg font-semibold text-richblack-5">
                Study<span className="text-yellow-50">Meet</span>
              </h2>
              <p className="mb-4">
                StudyMeet is an online learning space focused on practical
                courses, simple navigation, and a calm interface so you can find
                what you need and get back to studying. The goal is to combine
                structured content with a modern experience — from browsing the
                catalog to tracking progress as you go.
              </p>
              <p>
                If you want to explore courses, head to the{" "}
                <Link
                  to="/catalog/Web%20Development"
                  className="font-semibold text-yellow-50 underline decoration-yellow-50/40 underline-offset-4 transition hover:text-yellow-25 hover:decoration-yellow-50"
                >
                  catalog
                </Link>
                .
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
